import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formats a content date identically on the server and in the browser. A
 * locale- or timezone-dependent format makes hydration fail, and React then
 * discards the server HTML and re-renders the whole page on the client.
 */
export function formatDate(date: string, month: 'short' | 'long' = 'short') {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month,
    day: 'numeric',
    timeZone: 'UTC',
  });
}
